<div class="app-body">
  <main class="main d-flex align-items-center min-vh-100">
    <div class="container">
      <div class="col-md-5 mx-auto">
        <div class="card shadow-lg">
          <div class="card-body p-5">
            <div class="text-center mb-4">
              <img
                src="/assets/img/brand/firm360-logo-v2.png"
                alt="Firm360 Logo"
                class="logo"
              />
            </div>

            <h1 class="h4 text-center mb-3">Reset your password</h1>
            @if (!success && !error) {
              <p class="text-muted text-center mb-4">
                Enter the email address you used to register.
              </p>
            }

            @if (error) {
              <div class="alert alert-danger">
                We could not process your request. Please try again.
              </div>
            }

            @if (success === "OK") {
              <div class="alert alert-success">
                <p class="mb-0">
                  We sent a password reset link to the email address provided.
                </p>
              </div>
            }

            @if (!success) {
              <form
                (ngSubmit)="requestReset()"
                [formGroup]="resetRequestForm"
                name="form"
                role="form"
              >
                <div class="form-floating">
                  <input
                    #emailField
                    class="form-control mb-0"
                    formControlName="email"
                    id="email"
                    name="email"
                    placeholder="Email Address"
                    type="email"
                  />
                  <label for="email">Email Address</label>
                </div>
                <div class="h-30 mb-2">
                  @if (
                    resetRequestForm.get("email").errors?.required &&
                    resetRequestForm.get("email").touched
                  ) {
                    <p class="text-danger">
                      <small>This field is required.</small>
                    </p>
                  }
                  @if (
                    resetRequestForm.get("email").errors?.email &&
                    resetRequestForm.get("email").touched
                  ) {
                    <p class="text-danger">
                      <small>Please enter a valid email.</small>
                    </p>
                  }
                  @if (
                    resetRequestForm.get("email").errors?.minlength &&
                    resetRequestForm.get("email").touched
                  ) {
                    <p class="text-danger">
                      <small
                        >Your email is required to be at least 5
                        characters.</small
                      >
                    </p>
                  }
                  @if (
                    resetRequestForm.get("email").errors?.maxlength &&
                    resetRequestForm.get("email").touched
                  ) {
                    <p class="text-danger">
                      <small
                        >Your email cannot be longer than 254 characters.</small
                      >
                    </p>
                  }
                </div>
                <button
                  [disabled]="resetRequestForm.invalid"
                  class="btn btn-sign-up w-100"
                  type="submit"
                >
                  Submit
                </button>
                <div class="text-center mt-3">
                  <a routerLink="/login" class="link">Back to sign in</a>
                </div>
              </form>
            }
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
